// App shell: sidebar, top bar, account menu.
export const layoutEn = {
  'layout.brandName': 'Digimasi CMS',
  'layout.brandSub': 'Website CMS',
  'layout.nav.group.overview': 'Overview',
  'layout.nav.group.content': 'Content',
  'layout.nav.group.catalogue': 'Catalogue',
  'layout.nav.group.leads': 'Leads',
  'layout.nav.group.store': 'Store',
  'layout.nav.orders': 'Orders',
  'layout.nav.customers': 'Customers',
  'layout.nav.promos': 'Discount codes',
  'layout.nav.reports': 'Sales report',
  'layout.nav.lowStock': 'Low stock',
  'layout.nav.payments': 'Payments',
  'layout.nav.lowStockCount': '{n} variants low on stock',
  'layout.nav.group.site': 'Site',
  'layout.nav.dashboard': 'Dashboard',
  'layout.nav.pages': 'Pages',
  'layout.nav.articles': 'Journal & News',
  'layout.nav.media': 'Media Library',
  'layout.nav.categories': 'Categories',
  'layout.nav.products': 'Products',
  'layout.nav.industries': 'Industries',
  'layout.nav.swatches': 'Materials & Finishes',
  'layout.nav.inquiries': 'Quote Requests',
  'layout.nav.messages': 'Messages',
  'layout.nav.mailbox': 'Inbox',
  'layout.nav.livechat': 'Live chat',
  'layout.nav.livechatWaiting': '{n} chats need a person',
  'layout.nav.navigation': 'Header & Footer',
  'layout.nav.specReference': 'Specification Reference',
  'layout.nav.settings': 'SEO & Settings',
  'layout.nav.users': 'Users',
  'layout.nav.roles': 'Roles',
  'layout.nav.plan': 'Plan & Usage',
  'layout.searchMenu': 'Search menu',
  'layout.viewSite': 'View site',
  'layout.shell.openMenu': 'Open menu',
  'layout.shell.closeMenu': 'Close menu',
  'layout.shell.menuTitle': 'Menu',
  'layout.shell.account': 'Account',
  'layout.shell.profile': 'Profile',
  'layout.shell.theme': 'Theme',
  'layout.shell.themeLight': 'Light',
  'layout.shell.themeDark': 'Dark',
  'layout.shell.themeSystem': 'System',
  'layout.shell.signOut': 'Sign out',
} as const

export const layoutId: Record<keyof typeof layoutEn, string> = {
  'layout.brandName': 'Digimasi CMS',
  'layout.brandSub': 'CMS Website',
  'layout.nav.group.overview': 'Ikhtisar',
  'layout.nav.group.content': 'Konten',
  'layout.nav.group.catalogue': 'Katalog',
  'layout.nav.group.leads': 'Prospek',
  'layout.nav.group.store': 'Toko',
  'layout.nav.orders': 'Pesanan',
  'layout.nav.customers': 'Pelanggan',
  'layout.nav.promos': 'Kode promo',
  'layout.nav.reports': 'Laporan penjualan',
  'layout.nav.lowStock': 'Stok menipis',
  'layout.nav.payments': 'Pembayaran',
  'layout.nav.lowStockCount': '{n} varian stoknya menipis',
  'layout.nav.group.site': 'Situs',
  'layout.nav.dashboard': 'Dasbor',
  'layout.nav.pages': 'Halaman',
  'layout.nav.articles': 'Jurnal & Berita',
  'layout.nav.media': 'Pustaka Media',
  'layout.nav.categories': 'Kategori',
  'layout.nav.products': 'Produk',
  'layout.nav.industries': 'Industri',
  'layout.nav.swatches': 'Bahan & Finishing',
  'layout.nav.inquiries': 'Penawaran Masuk',
  'layout.nav.messages': 'Pesan Masuk',
  'layout.nav.mailbox': 'Kotak Masuk',
  'layout.nav.livechat': 'Live chat',
  'layout.nav.livechatWaiting': '{n} chat perlu dibalas orang',
  'layout.nav.navigation': 'Header & Footer',
  'layout.nav.specReference': 'Referensi Spesifikasi',
  'layout.nav.settings': 'SEO & Pengaturan',
  'layout.nav.users': 'Pengguna',
  'layout.nav.roles': 'Peran',
  'layout.nav.plan': 'Paket & Penggunaan',
  'layout.searchMenu': 'Cari menu',
  'layout.viewSite': 'Lihat situs',
  'layout.shell.openMenu': 'Buka menu',
  'layout.shell.closeMenu': 'Tutup menu',
  'layout.shell.menuTitle': 'Menu',
  'layout.shell.account': 'Akun',
  'layout.shell.profile': 'Profil',
  'layout.shell.theme': 'Tema',
  'layout.shell.themeLight': 'Terang',
  'layout.shell.themeDark': 'Gelap',
  'layout.shell.themeSystem': 'Sistem',
  'layout.shell.signOut': 'Keluar',
}
